export default {
  path: '/',
  component: () => import('./Index'),
  meta: {
    title: '荟友官网',
    designWidth: 750
  }
}
